import { deburr } from "lodash";

export function capitalizeFirst(s: string): string {
	return s.charAt(0).toUpperCase() + s.slice(1);
}

export function nFirstCharOnly(s: string, n: number): string {
	return s.length < n ? s : s.slice(0, n) + "...";
}

export function containsNoSpecialCaractere(s: string): boolean {
	return /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]+/g.test(s);
}

export const removeSpecialCaracters = (s: string): string => {
	return s.replaceAll(/[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]+/g, "");
};

// suppression d'accent
export const normalizedString = (s: string): string => {
	return deburr(s);
};

export const truncString = (s: string, numberOfCaracter: number): string => {
	if (s.length > numberOfCaracter) return s.slice(0, numberOfCaracter).concat("", "...");
	return s;
};

export function capitalizeWord(s: string): string {
	return s.toUpperCase();
}
